module.exports = __webpack_public_path__ + "img/P150T_weapon_43.fe6dae0c.png";